import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            { attrs: { cols: "12" } },
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    [
                      _vm._v(" Current Inventory Balance "),
                      _c(VSpacer),
                      _c(VCheckbox, {
                        staticClass: "mt-0",
                        attrs: {
                          label: "Hide items with zero value",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.hideZeroValue,
                          callback: function ($$v) {
                            _vm.hideZeroValue = $$v
                          },
                          expression: "hideZeroValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    VCardText,
                    [
                      _c(VDataTable, {
                        staticClass: "elevation-1",
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.filteredItems,
                          loading: _vm.loading,
                          "items-per-page": _vm.itemsPerPage,
                          page: _vm.page,
                          "footer-props": {
                            itemsPerPageOptions: [
                              5,
                              10,
                              25,
                              { text: "All", value: -1 },
                            ],
                            showFirstLastPage: true,
                          },
                        },
                        on: {
                          "update:page": function ($event) {
                            _vm.page = $event
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.quantityRemaining",
                            fn: function ({ item }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatQuantity(item.quantityRemaining)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.currentValue",
                            fn: function ({ item }) {
                              return [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatCurrency(item.currentValue)
                                    ) +
                                    " "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.items.length > 0
        ? _c(
            VRow,
            { staticClass: "mt-4" },
            [
              _c(
                VCol,
                { staticClass: "text-right", attrs: { cols: "12" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { color: "secondary" },
                      on: { click: _vm.downloadCsv },
                    },
                    [_vm._v(" Download CSV ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }